<template>
  <div class="collision-check h-full overflow-hidden relative" v-loading="!modelLoadEnd">
    <categoryTitle class="mt-10px" title="碰撞检查记录" />
    <div class="flex items-center search-wrap my-5px">
      <!-- <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入关键词"
        clearable
        class="flex-0"
        @keypress.native.enter="searchList"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="searchList"></i>
      </el-input> -->
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入关键词"
        clearable
        @keypress.native.enter="searchList"
        @clear="searchList"
      ></el-input>
      <el-button @click="searchList" size="small" type="primary" class="ml-10px">搜索</el-button>
      <el-button @click="newCheck" size="small" type="primary" class="ml-10px">新增检查</el-button>
      <!-- <div
        class="
          text-center
          button-bg-img
          text-white
          h-28px
          leading-28px
          px-15px
          ml-5px
          cursor-pointer
          whitespace-nowrap
        "
        @click="newCheck"
      >
        新增检查
      </div> -->
    </div>
    <el-table
      :data="tableData"
      :height="`calc(50% - 99px)`"
      class="collision-table"
      highlight-current-row
      row-key="id"
      stripe
    >
      <el-table-column prop="no" label="碰撞编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="checkTime" label="检查日期" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="{ row }">
          <span @click="collisionEdit(row)" size="small" class="text-[#44F1FF] cursor-pointer"
            >编辑</span
          >
          <span
            @click="collisionPreview(row)"
            size="small"
            class=" ml-10px text-[#44F1FF] cursor-pointer"
            >查看</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      class="mt-5px flex justify-end"
      background
      @current-change="getTableData"
      :current-page="pageNo"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      :pager-count="5"
      popper-class="visualization-select-popper"
    >
    </el-pagination>
    <categoryTitle class="my-10px" title="碰撞检查详情" />
    <div class="h-[calc(50%-38px)] text-16px overflow-auto">
      <div class="flex py-6px" v-for="(item, index) in detailCol" :key="index">
        <div class="w-100px flex-shrink-0 text-[#b9b9b9] text-right">{{ item.name }}：</div>
        <div
          v-if="item.code === 'pos'"
          class="flex-grow text-[#fff] truncate"
          :title="`X:${detailData.xPosition} Y:${detailData.yPosition} Z:${detailData.zPosition}`"
        >
          {{
            detailData.xPosition
              ? `X:${detailData.xPosition} Y:${detailData.yPosition} Z:${detailData.zPosition}`
              : ''
          }}
        </div>
        <div
          v-else
          class="flex-grow text-[#fff]"
          :title="item.ellipsis ? detailData[item.code] : false"
          :class="[
            item.ellipsis ? 'truncate' : 'leading-20px',
            {
              '!text-[#44f1ff] cursor-pointer':
                item.code === 'mainName' || item.code === 'guestName',
            },
          ]"
          @click="detailClick(item.code, detailData[item.code])"
        >
          {{ detailData[item.code] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { CollisionCheckApi } from '@wiz-api/haiguang'
import { multipleLocations } from './js/publicModelMays'
import EventBus from './js/eventBus'

const collisionCheckApi = new CollisionCheckApi()

export default {
  name: 'CollisionCheck',
  components: { categoryTitle },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 模型加载完成
    modelLoadEnd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      total: 0,
      keyWord: '',
      materialObj: {
        previewSubNodePtr: null,
        previewObNodePtr: null,
        subMaterial: null,
        obMaterial: null,
      },
      detailData: {
        no: '',
        checkTime: '',
        mainCode: '',
        mainName: '',
        guestCode: '',
        guestName: '',
        xPosition: '',
        yPosition: '',
        zPosition: '',
        description: '',
      },
      detailCol: [
        {
          code: 'no',
          name: '碰撞编号',
          ellipsis: true,
        },
        {
          code: 'checkTime',
          name: '创建日期',
          ellipsis: true,
        },
        {
          code: 'mainCode',
          name: '主体编码',
          ellipsis: true,
        },
        {
          code: 'mainName',
          name: '主体名称',
          ellipsis: true,
        },
        {
          code: 'guestCode',
          name: '客体编码',
          ellipsis: true,
        },
        {
          code: 'guestName',
          name: '客体名称',
          ellipsis: true,
        },
        {
          code: 'pos',
          name: '碰撞点坐标',
          ellipsis: true,
        },
        {
          code: 'description',
          name: '碰撞描述',
          ellipsis: false,
        },
      ],
      tableData: [],
    }
  },
  watch: {},
  methods: {
    // 新增检查
    newCheck() {
      this.$emit('transferEvent', {
        toCom: { code: 'NewCollisionCheck', origin: 'CollisionCheck', name: '新建碰撞检查' },
        type: 'mainComponent',
        props: {
          materialObj: this.materialObj,
        },
      })
    },
    async detailClick(type, name) {
      if ((type === 'mainName' || type === 'guestName') && this.player) {
        const treeData = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
        const rootNode = treeData[0]?.nodePtr
        if (rootNode) {
          const curNode = await this.player.Native.NodeProxy.findFirstNodeByName(rootNode, name)
          if (curNode) {
            const NodeInfo = await this.player.Native.NodeProxy.getNodeInfo(curNode)
            if (!NodeInfo || !NodeInfo.item) {
              this.$message.warning('当前加载无item节点')
            }
            console.log('NodeInfo', NodeInfo)
            multipleLocations(this.player, NodeInfo)
          } else {
            this.$message.warning('未找到当前节点')
          }
        }
      }
    },
    // 获取表数据
    async getTableData() {
      this.tableData.length = 0
      this.total = 0
      const [err, res] = await collisionCheckApi.getCollisionCheckList({
        body: {
          maxResultCount: this.pageSize,
          skipCount: (this.pageNo - 1) * this.pageSize,
          sorting: '',
          keywords: this.keyWord,
          tenantId:
            localStorage.getItem('CurrentTenantId') ||
            localStorage.getItem('TenantId') ||
            JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId,
        },
      })
      if (!err && res && res.items) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.detailData = this.$options.data().detailData
    },
    // 重置碰撞预览颜色
    async resetNodeMaterial() {
      if (this.materialObj.previewSubNodePtr && this.materialObj.subMaterial) {
        await this.player.Native.NodeProxy.setNodeMaterial(
          this.materialObj.previewSubNodePtr,
          this.materialObj.subMaterial
        )
      }
      if (this.materialObj.previewObNodePtr && this.materialObj.obMaterial) {
        await this.player.Native.NodeProxy.setNodeMaterial(
          this.materialObj.previewObNodePtr,
          this.materialObj.obMaterial
        )
      }
      this.materialObj = this.$options.data().materialObj
      EventBus.$emit('listMaterialNodeChange', false)
    },
    materialNodeChange(data) {
      if (!data) {
        this.materialObj = this.$options.data().materialObj
      } else {
        this.materialObj = Object.assign(this.materialObj, data)
      }
    },
    // 碰撞预览
    async collisionPreview(row) {
      await this.resetNodeMaterial()
      this.detailData = Object.assign(this.detailData, row)
      const treeData = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      const rootNode = treeData[0]?.nodePtr
      if (rootNode) {
        this.player.Native.Camera.moveToPos(
          [parseFloat(row.xPosition), parseFloat(row.yPosition), parseFloat(row.zPosition)],
          rootNode,
          10,
          1
        )
        this.materialObj.previewSubNodePtr = await this.player.Native.NodeProxy.findFirstNodeByName(
          rootNode,
          row.mainName
        )
        this.materialObj.previewObNodePtr = await this.player.Native.NodeProxy.findFirstNodeByName(
          rootNode,
          row.guestName
        )
        if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
          this.materialObj.subMaterial = await this.player.Native.NodeProxy.getNodeMaterial(
            this.materialObj.previewSubNodePtr
          )
          this.materialObj.obMaterial = await this.player.Native.NodeProxy.getNodeMaterial(
            this.materialObj.previewObNodePtr
          )
          const newSubMaterial = await this.player.Native.NodeProxy.copyMaterial(
            this.materialObj.subMaterial
          )
          const newObMaterial = await this.player.Native.NodeProxy.copyMaterial(
            this.materialObj.obMaterial
          )
          await this.player.Native.NodeProxy.setMaterialDiffuse(newSubMaterial, 0xff0000ff)
          await this.player.Native.NodeProxy.setMaterialDiffuse(newObMaterial, 0x00ff00ff)
          await this.player.Native.NodeProxy.setNodeMaterial(
            this.materialObj.previewSubNodePtr,
            newSubMaterial
          )
          await this.player.Native.NodeProxy.setNodeMaterial(
            this.materialObj.previewObNodePtr,
            newObMaterial
          )
          EventBus.$emit('listMaterialNodeChange', this.materialObj)
        } else {
          this.$message.warning('未查找到模型节点')
        }
      }
    },
    // 碰撞编辑
    collisionEdit(row) {
      const filterEvent = new CustomEvent('openCollisionEdit', {
        detail: {
          ...row,
        },
      })
      window.dispatchEvent(filterEvent)
    },
    searchList() {
      this.pageNo = 1
      this.getTableData()
    },
  },
  beforeDestroy() {
    this.resetNodeMaterial()
    EventBus.$off('CollisionEditSuccess', this.searchList)
    EventBus.$off('materialNodeChange', this.materialNodeChange)
  },
  created() {
    EventBus.$on('CollisionEditSuccess', this.searchList)
    EventBus.$on('materialNodeChange', this.materialNodeChange)
    this.getTableData()
    this.$emit('collisionReload')
  },
}
</script>
<style lang="scss" scoped>
.collision-check {
  .search-wrap {
    ::v-deep .el-input__inner {
      background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
      border: none !important;
      background-size: 100% 100% !important;
      border-radius: unset !important;
    }
    ::v-deep .el-button {
      background-color: rgb(67 153 174 / 35%) !important;
      background-image: none !important;
      border: 1px solid #629eaa !important;
      border-radius: 2px !important;
      height: 36px !important;
    }
  }
  .collision-table {
    ::v-deep .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #adadad !important;
      &::after {
        left: 4px !important;
        top: 0px !important;
      }
    }
    ::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #fff !important;
    }
    ::v-deep .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: transparent !important;
    }
    ::v-deep .el-table__row.el-table__row--striped {
      background: linear-gradient(0deg, #17c5dc5e, #1de3fd1a);
    }
    ::v-deep .el-table__body .current-row {
      background: linear-gradient(0deg, #986c36, #986c3666);
    }
  }
  .button-bg-img {
    background: url('../../../assets/images/button_blue.png');
    background-size: 100% 100%;
  }
  ::v-deep {
    // .el-input--small .el-input__inner {
    //   height: 28px !important;
    //   line-height: 28px !important;
    // }
    // .el-input__suffix i {
    //   height: 28px !important;
    //   line-height: 28px !important;
    // }
    .el-pagination.is-background.el-pagination--small .btn-next,
    .el-pagination.is-background.el-pagination--small .btn-prev,
    .el-pagination.is-background.el-pagination--small .el-pager li {
      min-width: 26px !important;
      margin: 0 4px !important;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      border-color: var(--cockpitInputBorderColor) !important;
    }
  }
}
</style>
